<script>
	import ExitModal from '../../../components/v0/Modal/ExitModal.svelte';
	export let onMouseDown = () => {};
	export let startNew = () => {};
	export let goBack = () => {};
	export let gameOrRound = '';
</script>

<div class="exitModalScreen">
	<ExitModal {onMouseDown} {startNew} {goBack} {gameOrRound} />
</div>

<style>
	.exitModalScreen {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background: rgba(0, 0, 0, 0.7);
	}
</style>
